import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Taxes Name",
    "Tax(%)",
    "Status",
    "Action"
  ];
  
  export const TABLE_DATA = [
    { id: 1, name: "CGST",tax:9,  description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, name: "SGST",tax:9,  description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, name: "IGST",tax:18,  description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Taxes Name": "tax_name",
    "Tax(%)":"tax_percent",
    "Description":"tax_desc",
    
    "Status": "status",
    "Action": [
        { type: "edit", icon: editIcon, label: "Edit" },
        
      ]
  };